import { Badge } from "@/components/ui/badge"
import { IconPlus } from "@tabler/icons-react"
import * as React from "react"

export const AddTagButton = React.forwardRef<
  HTMLSpanElement,
  { onClick?: () => void }
>(({ onClick, ...props }, ref) => {
  return (
    <span ref={ref} {...props}>
      <Badge
        variant={"outline"}
        className="mt-1 hover:cursor-pointer hover:opacity-70"
        onClick={onClick}
      >
        <IconPlus size={12} />
      </Badge>
    </span>
  )
})
AddTagButton.displayName = "AddTagButton"
